<template>
<!-- 小鹅通反馈统计 -->
    <div class="el-card  pd20">
        <!-- add---新增 -->
        <div class="add-box">
            <router-link to="/main/gen_statistics_form">
                <el-button type="primary" size="medium">新增统计</el-button>
            </router-link>
            <!--  -->
            <el-button style="margin-left:20px;" type="info" @click="cloumnShow=!cloumnShow" plain size="medium">切换列数</el-button>
        </div>
        <!--  -->
        <div class="el-card  pd20 content">
            <el-table :data="list" border style="width: 100%">
                <el-table-column type="index" width="100" label="序号"></el-table-column>
                <el-table-column prop="channel_name" label="渠道名" ></el-table-column>
                <el-table-column v-if="cloumnShow" prop="ad_date" label="投放日期"></el-table-column>
                <el-table-column v-if="cloumnShow" prop="ad_day" label="投放时间" > </el-table-column>
                <el-table-column v-if="cloumnShow" prop="pub_time" label="发布时间" > </el-table-column>
                <el-table-column v-if="cloumnShow" prop="locate" label="位置" > </el-table-column>
                <el-table-column v-if="cloumnShow" prop="est_fans" label="预估粉丝数" > </el-table-column>
                <el-table-column prop="ad_fee" label="投放费用" > </el-table-column>
                <el-table-column v-if="cloumnShow" prop="views_avg" label="历史平均阅读量" > </el-table-column>
                <el-table-column v-if="cloumnShow" prop="ad_article" label="投放软文" > </el-table-column>
                <el-table-column v-if="cloumnShow" prop="article_title" label="软文标题" > </el-table-column>
                <el-table-column v-if="cloumnShow" prop="views_24h" label="24小时阅读量" > </el-table-column>
                <el-table-column v-if="cloumnShow" prop="detail_uv" label="详情页UV" > </el-table-column>
                <el-table-column v-if="cloumnShow" prop="detail_conv" label="详情页转化率" > </el-table-column>
                <el-table-column prop="seven_buy_count" label="9.9获客数" > </el-table-column>
                <el-table-column prop="ad_article_conv" label="软文转化率" > </el-table-column>
                <el-table-column prop="cus_cost" label="获客成本" > </el-table-column>
                <el-table-column prop="course_buy_count" label="进阶课付费人数" > </el-table-column>
                <el-table-column prop="seven_conv" label="训练营转换率" > </el-table-column>
                <el-table-column v-if="cloumnShow" prop="bid_2_count" label="自我探索报名数" > </el-table-column>
                <el-table-column v-if="cloumnShow" prop="bid_1_count" label="个人战略报名数" > </el-table-column>
                <el-table-column v-if="cloumnShow" prop="joint_count" label="联报人数" > </el-table-column>
                <el-table-column prop="joint_conv" label="联报率" > </el-table-column>
                <el-table-column prop="cus_pay" label="平均客单价" > </el-table-column>
                <el-table-column prop="sum_pay" label="总消费金额" > </el-table-column>
                <el-table-column prop="roi" label="渠道ROI" > </el-table-column>
                <el-table-column label="备注" >
                    <template slot-scope="scope">
                        <span class="remarkSpan" @click="editRemark(scope.row)">
                            <span class="remarkSpan-1" v-if="scope.row.remark">{{scope.row.remark}}</span>
                            <span class="remarkSpan-2" v-else>暂无备注</span>
                        </span>
                        
                    </template>
                </el-table-column>
                <el-table-column width="180"  label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" icon="el-icon-edit" @click="edit(scope.$index, scope.row,'edit')" circle></el-button>
                        <el-button type="primary" size="mini" icon="el-icon-view" @click="genView(scope.$index, scope.row)" circle></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination class="pages" 
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="pages.size" 
                :current-page="pages.page"
                background 
                layout="sizes,prev, pager, next" 
                :total="pages.count"> 
            </el-pagination>
        </div>
        <!-- 修改备注 -->
        <el-dialog title="修改备注" :visible.sync="dialogRemark">
            <el-form :model="form">
                <el-form-item label="备注" :label-width="formLabelWidth">
                    <el-input type="textarea" :rows="3" v-model="remarkObj.remark" ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogRemark = false">取 消</el-button>
                <el-button type="primary" @click="saveRemark()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { statList,updateStatRemark } from "@/api/operating";
export default {
    data() {
        return{
            formLabelWidth:'120px',
            pages:{},
            list:[],
            cloumnShow:false,
            // 
            bid:null,
            state:null,
            status:null,
            // 所有课程列表
            course_list:[],
            course_list2:[],
            obj:{},
            // 备注
            dialogRemark:false,
            remarkObj:{
                id:null,
                remark:''
            }
        }
    },
    methods:{
        /*
         *@param: 
         *@return: 
         *@Description: 查看统计详情
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-06 11:11:47
        */
        genView(index,row){
            this.$router.push({
                path:'/main/gen_statistics_details',
                query:{
                    id:row.id
                }
            });
        },
        /*
         *@param: 
         *@return: 
         *@Description: 提交已修改备注
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-06 11:11:47
        */
        saveRemark(){
            updateStatRemark(this.remarkObj).then(data=>{
                if(data.error >0){
                    this.$message(data.msg);
                    return
                }
                this.dialogRemark = false;
                this.$notify({
                    title: '成功',
                    message: '修改成功！',
                    type: 'success'
                });
                this.pullData();
            });
        },
        /*
         *@param: row 被点击行的对象
         *@return: 
         *@Description: 点击备注列触发
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-01-06 11:06:06
        */
        editRemark(row){
            this.remarkObj.id = row.id;
            this.remarkObj.remark = row.remark;
            this.dialogRemark = true;
        },
        /*
         *@param: 
         *@return: 
         *@Description: 跳转修改
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-12-17 17:45:19
        */
        edit(index,row){
            this.$router.push({
                path:'/main/gen_statistics_form',
                query:{
                    id:row.id
                }
            });
        },
         // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        pullData(){
            this.$showLoading();
            this.obj = {
                page:Object.keys(this.pages).length>0?this.pages.page:1,  //页码，默认1
                size:Object.keys(this.pages).length>0?this.pages.size:25   //每页数量，默认25
            };

            statList(this.obj).then((data)=>{
                this.list = data.list;
                this.pages = data.pager;

                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.add-box{
    margin-bottom: 20px;
    display: flex;
}
.content{
    padding: 20px;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.search{
    margin-left: auto;
    text-align: right;
}
.search-child{
    margin-left: 20px;
}
.remarkSpan{
    display: block;
    width: 100%;
    height: 100%;
    min-height: 30px;
    .remarkSpan-1{
        color: #1989fa;
        text-decoration: underline;
    }
    .remarkSpan-2{
        color: #cccccc;
    }
}
</style>
